export const INITIAL_FILTERS = {
    price: {
        min: 0,
        max: 10000,
    },
    manufacturers: [],
};
